const performanceDashboard = {
  title: 'Painel de Desempenho',
  subTitle: 'Visão geral das principais métricas operacionais',
  supplierSelector: {
    label: 'Escolher Fornecedor:',
  },
  acceptDeclineTripsPie: {
    title: 'Viagens Aceitas / Recusadas',
    pies: {
      accept: 'Aceitar',
      decline: 'Recusar',
    },
  },
  assignmentTypePie: {
    title: 'Tipo de Atribuição',
    pies: {
      manual: 'Manual',
      automated: 'Automatizado',
    },
  },
  coverageCapacityChart: {
    title: 'Capacidade de Cobertura',
    bars: {
      capacity: 'Capacidade',
    },
  },
  fleetAcceptanceChart: {
    title: 'Aceitação da Frota',
    bars: {
      acceptance: 'Aceitação',
    },
  },
  noShowCancelationChart: {
    title: 'Taxas de Não Comparecimento e Cancelamento',
    bars: {
      noShow: 'Não Compareceu',
      cancelation: 'Cancelamento',
    },
  },
  onTimePerformanceChart: {
    title: 'Pontualidade',
    bars: {
      onTime: 'No horário',
    },
  },
};

export default performanceDashboard;
